import(/* webpackMode: "eager" */ "/app/src/app/(modules)/layout.tsx");
